import { FC, useEffect, useState } from "react";

import { Spin, Table } from "antd";
import { Button } from "../../../ui-components/Button";
import { Modal } from "../../../ui-components/Modal";

import { State } from "../../../utils/store";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import {
  CampaignAccessDataUser,
  updateUsersAccess,
  CampaignAccessChangeOrigin,
} from "../store";
import { UserRole } from "../../../auth/store";

import { UserCampaignAccessWidgetColumns } from "./widget-table/columns";

interface UpdateTagModalProps {
  visible: boolean;
  handleModalClose: () => void;
  campaignUUID: string;
  campaignName: string;
  users: CampaignAccessDataUser[];
}

export const EditCampaignAccessModal: FC<UpdateTagModalProps> = ({
  visible,
  handleModalClose,
  campaignUUID,
  campaignName,
  users,
}) => {
  const dispatch = useAppDispatch();
  const { selectedClient } = useAppSelector((state: State) => state.clients);

  const modalTitle = `Edit campaign "${campaignName}" access rights`;
  const [usersData, setUsersData] = useState<CampaignAccessDataUser[]>([]);

  const toggleUserAccess = (userUUID: string, setHasAccess: boolean) => {
    const userIndex = usersData.findIndex((user) => user.uuid === userUUID);
    let newUserData = [...usersData];
    newUserData[userIndex] = {
      ...newUserData[userIndex],
      hasAccessToCampaign: setHasAccess,
    };
    setUsersData(newUserData);
  };

  const { loading } = useAppSelector(
    (state: State) => state.campaignAccessManagement.updateUsersAccess
  );
  const userCampaignAccessColumns =
    UserCampaignAccessWidgetColumns(toggleUserAccess);

  useEffect(() => {
    setUsersData([...users]);
  }, [users]);

  const handleSubmit = () => {
    if (!selectedClient) return;

    const nonAdminUsers = usersData.filter(
      (user) => user.role !== UserRole.ADMIN
    );
    const registeredUsers = nonAdminUsers.filter(
      (user) => !user.invitationPendingStatus
    );
    const enabledUsers = registeredUsers
      .filter((user) => user.hasAccessToCampaign)
      .map((user) => user.uuid);
    const disabledUsers = registeredUsers
      .filter((user) => !user.hasAccessToCampaign)
      .map((user) => user.uuid);

    const userAccessData = {
      clientUUID: selectedClient.uuid,
      enabledUsers: enabledUsers,
      disabledUsers: disabledUsers,
      campaignUUID: campaignUUID,
      accessOrigin: CampaignAccessChangeOrigin.CAMPAIGN_ADMIN_MANAGEMENT,
    };

    dispatch(updateUsersAccess(userAccessData));
  };

  return (
    <Modal
      title={modalTitle}
      visible={visible}
      handleSubmit={handleSubmit}
      onCancel={handleModalClose}
      footer={[
        <Button key="cancel" onClick={handleModalClose}>
          Cancel
        </Button>,
        <Button key="confirm" htmlType="submit" onClick={() => handleSubmit()}>
          {loading ? (
            <>
              Sending &nbsp; <Spin />
            </>
          ) : (
            "Save"
          )}
        </Button>,
      ]}
    >
      <Table
        dataSource={users}
        columns={userCampaignAccessColumns as any}
        rowKey={(record: any) => (record && record.uuid) || ""}
        loading={loading}
      />
    </Modal>
  );
};
